document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.product__info-wrapper').hasAttribute('data-discontinued')) {
    return;
  }
  makeAddToCartSticky();
  suscriptionWidgetUpdates();
  // updateKlarnaPlacement();
});

function makeAddToCartSticky() {
  // Get the header height
  const header = document.querySelector('header');
  const headerHeight = header.offsetHeight;
  const stickyHeader = document.querySelector('.section-header');

  /* Avoid layout shift */
  const formPlaceHolder = document.querySelector('.product-form-placeholder');
  const placeholderHeight = formPlaceHolder.offsetHeight;
  // formPlaceHolder.style.height = placeholderHeight + 'px';

  /* Append the Sticky Product Form container to Header */
  const stickyForm = document.querySelector('#sticky-product-header');
  stickyHeader.appendChild(stickyForm);

  function handleStickyFormVisibility() {
    const rect = formPlaceHolder.getBoundingClientRect();
    if (window.scrollY > rect.bottom + window.scrollY - headerHeight) {
      // If the scroll position is below the bottom of the form placeholder plus the header height,
      // move the form content to the sticky form container and show the sticky header.
      const formContent = document.querySelector('.product-form-content');
      stickyForm.appendChild(formContent);
      stickyHeader.classList.add('product-form-visible');
      stickyForm.style.display = 'flex';
    } else {
      // If the scroll position is above the bottom of the form placeholder plus the header height,
      // and the form placeholder doesn't have any child elements,
      // move the form content back to the form placeholder and hide the sticky header.
      // this will avoid elements from re-animating when scrolling up and down.
      if (formPlaceHolder.children.length == 0) {
        const formContent = document.querySelector('.product-form-content');
        formPlaceHolder.appendChild(formContent);
        stickyHeader.classList.remove('product-form-visible');
        stickyForm.style.display = 'none';
      }
    }
  }

  window.addEventListener('scroll', handleStickyFormVisibility);
}

function suscriptionWidgetUpdates() {
  const shopifySubscriptionsAppBlockLabelChildren = document.querySelectorAll(
    '.shopify_subscriptions_app_block_label_children li label'
  );
  shopifySubscriptionsAppBlockLabelChildren.forEach((label) => {
    const labelText = label.childNodes[2].textContent.trim();
    const percentage = labelText.split(', ')?.[1]?.split(' ')?.[0] || '';
    const frecuency = labelText.split(', ')?.[0]?.split('Delivery ')?.[1] || '';

    let inputElement = label.querySelector('input');
    let price = '';
    if (inputElement) {
      price = inputElement.getAttribute('data-variant-price').split(' ')[0];
    }
    label.childNodes[2].textContent = `Subscribe & Save: ${price}`;

    let spanElement = document.createElement('span');
    spanElement.textContent = `Auto-ship ${frecuency} and save up to ${percentage}. Cancel anytime.`;
    spanElement.classList.add('shopify_subscriptions_app_block_label_children_subtitle');
    label.parentElement.appendChild(spanElement);
  });

  const prices = document.querySelectorAll('.shopify_subscriptions_in_widget_price');
  prices.forEach((node) => {
    if (node.textContent.includes(' ')) {
      node.textContent = node.textContent.split(' ')[0];
    }
  });
}

function updateKlarnaPlacement() {
  const targetDiv = document.querySelector(
    '.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper:has(input:first-child:checked)'
  );
  const klarnaPlacement = document.querySelector('klarna-placement');

  if (targetDiv) {
    // Create the new wrapper divs
    const outerWrapper = document.createElement('div');
    outerWrapper.style.display = 'flex';
    outerWrapper.style.flexDirection = 'column';
    outerWrapper.style.gap = '8px';

    const innerWrapper = document.createElement('div');
    innerWrapper.style.display = 'flex';
    innerWrapper.style.flexDirection = 'row';

    // Move existing children into the inner wrapper
    while (targetDiv.firstChild) {
      innerWrapper.appendChild(targetDiv.firstChild);
    }

    const klarnaContainer = document.createElement('div');
    klarnaContainer.style.marginLeft = '36px';

    if (klarnaPlacement) {
      klarnaContainer.appendChild(klarnaPlacement);
    }

    // Append the new wrappers into the target div
    outerWrapper.appendChild(innerWrapper);
    outerWrapper.appendChild(klarnaContainer);
    targetDiv.appendChild(outerWrapper);
  }

  console.log('updateKlarnaPlacement', targetDiv);
  console.log('updateKlarnaPlacement', klarnaPlacement);
}
